import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import {
    DistanceDisplayComponent,
    ImageCdnSrcDirective,
} from '@polaris-customerweb/sharedcomponents.shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RatingDisplayComponent } from 'src/app/components/shared/components/rating/rating-display/rating-display.component';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { CommunityItem } from 'src/app/models/community-item';
import { CommunityItemSearchFilter } from 'src/app/models/community-item-search-filter';
import { Pagination } from 'src/app/models/pagination';
import { LinkedTypeToUrlPipe } from 'src/app/pipes/linked-type-to-url.pipe';
import { RemoveWhiteSpacePipe } from 'src/app/pipes/remove-whitespace.pipe';
import { SnapshotToUrlPipe } from 'src/app/pipes/snapshot-to-url.pipe';
import { CommunityItemService } from 'src/app/services/community-item.service';

@Component({
    imports: [
        AnalyticsDirective,
        AngularSvgIconModule,
        DistanceDisplayComponent,
        ImageCdnSrcDirective,
        LinkedTypeToUrlPipe,
        NgOptimizedImage,
        RatingDisplayComponent,
        RemoveWhiteSpacePipe,
        RouterLink,
        RouterLinkActive,
        SnapshotToUrlPipe,
    ],
    selector: 'rdx-home-community',
    standalone: true,
    styleUrls: ['./home-community.component.scss'],
    templateUrl: './home-community.component.html',
})
export class HomeCommunityComponent {
    communityItems: CommunityItem[] = [];
    communityItemsLoaded = false;

    constructor(private communityItemService: CommunityItemService) {
        this.loadCommunityItems();
    }

    postToCommunity(): void {
        this.communityItemService.openNewPostDialog();
    }

    private loadCommunityItems(): void {
        this.communityItemService
            .getCommunityFeedItems$({
                pagination: new Pagination(3, 1),
            } as CommunityItemSearchFilter)
            .subscribe((items) => {
                this.communityItems = items;
                this.communityItemsLoaded = true;
            });
    }
}
